import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { Camera } from '@ionic-native/camera/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import {HttpClient } from "@angular/common/http";
import { AppComponent } from './app.component';
import { FloatingCallComponent } from './components/floating-call/floating-call.component';
import { AppRoutingModule } from './app-routing.module';
import {HttpClientModule} from "@angular/common/http";
import {Storage, IonicStorageModule} from "@ionic/storage";
import {JWT_OPTIONS, JwtModule} from '@auth0/angular-jwt';
import { DatePipe } from '@angular/common';
import { NgxAgoraModule, AgoraConfig } from 'ngx-agora';
import { CameraPreview } from '@ionic-native/camera-preview/ngx';
import {WebsocketService} from './services/websocket.service';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment.prod';
import { HttpModule } from '@angular/http';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { ChatAudioRecordingService } from '../app/services/chatAudioRecording.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { Clipboard } from '@ionic-native/clipboard/ngx';

const agoraConfig: AgoraConfig = {  
  AppID: '9574c9a0ff9d41aa842ef6cc89e2904f',
};

export function jwtOptionsFactory(storage: Storage) {
  return {  
    tokenGetter: () => storage.get('jwt_token'),
    whitelistedDomains: ['localhost:8080']
  }
}

@NgModule({
  declarations: [AppComponent, FloatingCallComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), 
    AppRoutingModule,HttpClientModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
   AngularFireDatabaseModule,
   HttpModule,
    JwtModule.forRoot({
      jwtOptionsProvider: { 
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [Storage]
      }
    }),
    IonicStorageModule.forRoot(),
    NgxAgoraModule.forRoot(agoraConfig)
  ],
  providers: [DatePipe,
    CameraPreview,
    Camera,
    File,
    Network,
    FileOpener,
    ChatAudioRecordingService,
    InAppBrowser,
    WebsocketService,
    Camera,
    File,
    FileOpener,
    FilePath,
    Clipboard,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {}
